type BuildTestIdParams = {
  testID: string | undefined;
  suffix?: string | string[];
};

/**
 * Normalizes a string into lowercase kebab-case, replacing
 * camelCase, dots, underscores, or spaces with hyphens.
 */
const normalizeToKebabCase = (value: string): string => {
  return value
    .replace(/([a-z])([A-Z])/g, '$1-$2') // handle camelCase → camel-case
    .replace(/[\s._]+/g, '-') // replace spaces, dots, underscores → hyphen
    .replace(/-+/g, '-') // avoid multiple consecutive hyphens
    .toLowerCase()
    .trim();
};

/**
 * Builds a consistent testID string from a base ID and optional suffix(es),
 * ensuring the output is kebab-case and properly formatted.
 */
export const buildTestId = ({
  testID,
  suffix,
}: BuildTestIdParams): string | undefined => {
  if (!testID) {
    return undefined;
  }

  const parts: string[] = [normalizeToKebabCase(testID)];

  if (Array.isArray(suffix) && suffix.length > 0) {
    parts.push(...suffix.map(normalizeToKebabCase));
  } else if (typeof suffix === 'string' && suffix.trim() !== '') {
    parts.push(normalizeToKebabCase(suffix));
  }

  return parts.join('-');
};
